export default __webpack_public_path__ + "static/media/ShortcutsMac.435b7470.png";